import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ProductInfoDrawer from "./modules/ProductInfoDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction, downloadFile } from '@/api/manage';
export default {
  name: 'ProductInfoList',
  mixins: [JeecgListMixin],
  components: {
    ProductInfoDrawer: ProductInfoDrawer
  },
  data: function data() {
    return {
      pagePath: '/ea/product/info',
      pageTitle: '产品清单',
      autoLoadInit: false,
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'code',
        colName: 'code',
        title: '产品编号',
        align: 'center'
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '产品名称',
        align: 'center'
      }, {
        dataIndex: 'model',
        colName: 'model',
        title: '规格型号',
        align: 'center'
      }, {
        dataIndex: 'category_dictText',
        colName: 'category',
        title: '产品类别',
        align: 'center'
      }, {
        dataIndex: 'unit_dictText',
        colName: 'unit',
        title: '计量单位',
        align: 'center'
      }, {
        dataIndex: 'price',
        colName: 'price',
        title: '出厂价格',
        align: 'center'
      }, {
        dataIndex: 'companyName',
        colName: 'companyName',
        title: '生产商',
        align: 'center'
      }, {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '状态',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      companyList: [],
      url: {
        queryCompany: '/ea/company/info/queryCompanyName',
        device: '/ea/product/equipment',
        chemical: '/ea/product/chemical',
        instrument: '/ea/product/instrument',
        reference: '/ea/product/reference',
        car: '/ea/product/car',
        list: '/ea/product/info' // delete: '/ea/product/info/delete/all',

      },
      //deletePart: '/delete/all',
      deviceColumns: [{
        dataIndex: 'material',
        colName: 'material',
        title: '产品材质',
        align: 'center'
      }, {
        dataIndex: 'repair',
        colName: 'repair',
        title: '维修周期',
        align: 'center'
      }],
      chemicalColumns: [{
        dataIndex: 'danger_dictText',
        colName: 'danger',
        title: '是否危化品',
        align: 'center'
      }, {
        dataIndex: 'type_dictText',
        colName: 'type',
        title: '危化品类别',
        align: 'center'
      }, {
        dataIndex: 'validity',
        colName: 'validity',
        title: '有效期（月）',
        align: 'center'
      }, {
        dataIndex: 'quantity',
        colName: 'quantity',
        title: '单位量',
        align: 'center'
      }],
      instrumentColumns: [{
        dataIndex: 'analysis_dictText',
        colName: 'analysis',
        title: '分析方法',
        align: 'center'
      }, {
        dataIndex: 'formula_dictText',
        colName: 'formula',
        title: '计算公式',
        align: 'center'
      }],
      referenceColumns: [{
        dataIndex: 'standard',
        colName: 'standard',
        title: '标准值',
        align: 'center'
      }],
      carColumns: [{
        dataIndex: 'type_dictText',
        colName: 'type',
        title: '车辆类型',
        align: 'center'
      }, {
        dataIndex: 'driving_dictText',
        colName: 'driving',
        title: '驱动型式',
        align: 'center'
      }],
      infoColumns: []
    };
  },
  props: {
    category: {
      type: Number,
      default: 11
    },
    title: {
      type: String,
      default: '设备'
    }
  },
  created: function created() {
    this.loadCompany();
    this.infoColumns = []; // this.queryParam.status = 1

    this.queryParam.category = this.category;

    if (this.category == 11 || this.category == 12) {
      this.url.list = this.url.device; // this.url.delete = this.url.device + this.deletePart

      this.infoColumns = this.insert(this.columns, this.deviceColumns, 8);

      if (this.category == 12) {
        this.url.list = this.url.instrument; //this.url.delete = this.url.instrument + this.deletePart

        this.infoColumns = this.insert(this.infoColumns, this.instrumentColumns, 10);
      }
    } else if (this.category == 21 || this.category == 22 || this.category == 23) {
      this.url.list = this.url.chemical; // this.url.delete = this.url.chemical + this.deletePart

      this.infoColumns = this.insert(this.columns, this.chemicalColumns, 8);

      if (this.category == 23) {
        this.url.list = this.url.reference; // this.url.delete = this.url.reference + this.deletePart

        this.infoColumns = this.insert(this.infoColumns, this.referenceColumns, 11);
      }
    } else if (this.category == 31) {
      this.url.list = this.url.car; // this.url.delete = this.url.car + this.deletePart

      this.infoColumns = this.insert(this.columns, this.carColumns, 8);
    } else {
      this.infoColumns = this.columns;
    }

    this.loadData();
  },
  computed: {},
  methods: {
    loadCompany: function loadCompany() {
      var that = this;
      that.companyList = [];
      getAction(this.url.queryCompany).then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
    },
    handleAdd: function handleAdd() {
      this.$refs.modalForm.category = this.category;
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增：' + this.title;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = false;
    },
    handleEdit: function handleEdit(record) {
      this.$refs.modalForm.category = this.category;
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑：' + this.title;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = true;
    },
    handleDetail: function handleDetail(record) {
      this.$refs.modalForm.category = this.category;
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = this.title + '详情';
      this.$refs.modalForm.disableSubmit = true;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = false;
    },
    handleCover: function handleCover(record) {
      this.$refs.modalForm.category = this.category;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '复制：' + this.title;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showContact = false;
    },
    modalFormOk: function modalFormOk() {
      this.queryParam = {
        category: this.category
      };
      this.loadData();
    },
    searchReset: function searchReset() {
      this.queryParam = {
        category: this.category
      };
      this.dates = {};
      this.loadData();
    },
    insert: function insert(arrfirst, arrlast, index) {
      if (index < 0) {
        index = 0;
      } else if (index > arrfirst.length) {
        index = arrfirst.length;
      }

      for (var i = arrlast.length - 1; i >= 0; i--) {
        arrfirst.splice(index, 0, arrlast[i]); //是在index位置用arrlast[i]替换掉arrfirst数组中的0个元素
      }

      return arrfirst;
    },
    // 导出
    handleExportXls: function handleExportXls(fileName) {
      if (!fileName || typeof fileName != 'string') {
        fileName = this.pageTitle + '导出文件';
      }

      var param = _objectSpread({}, this.queryParam);

      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        param['selections'] = this.selectedRowKeys.join(',');
      }

      param['category'] = this.category;
      var url = this.url.list + '/exportXls';
      downloadFile(fileName + '.xls', url, param);
    },

    /* 导入 */
    handleImportExcel: function handleImportExcel(info) {
      console.log('info', info);

      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }

      if (info.file.status === 'done') {
        if (info.file.response.success) {
          this.$message.success("".concat(info.file.name, " \u6587\u4EF6\u4E0A\u4F20\u6210\u529F"));
          this.loadData();
        } else {
          this.$message.error("".concat(info.file.name, " ").concat(info.file.response.message, "."));
        }
      } else if (info.file.status === 'error') {
        this.$message.error("\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25: ".concat(info.file.msg, " "));
      }
    },

    /*选择导入文件*/
    handleImportFile: function handleImportFile() {
      //debugger
      var url = this.url.list + '/importExcel';
      return "".concat(window._CONFIG['domianURL']) + url;
    },
    //  导出模板
    handleExportTemplate: function handleExportTemplate(fileName) {
      if (!fileName || typeof fileName != 'string') {
        fileName = this.pageTitle + '导出文件模板';
      }

      var url = this.url.list + '/exportXlsTemplate';
      downloadFile(fileName + '.xls', url);
    }
  }
};